import React, { Component } from 'react';
import Immutable from 'immutable';
import i18n from 'react-intl-universal';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import classNames from 'classnames';
import { Row, Col } from 'antd';
import Doyle from '@jianshu/doyle';
import styles from './RecyclePage.scss';
import { Trash } from '../../constants/actionTypes';
import { getTrashNotesList, getTrashNote, delTrashNote, recoveryTrashNote } from '../../actions/TrashAction';
import { getTrashNotesListState, getTrashNotesState } from '../../reducers/Trash/TrashNotesReducer';
import Message from '../../components/Message';
import EmptyContent from '../../components/EmptyContent/EmptyContent';
import NestLoading from '../../components/Loading/NestLoading';
import VerifyModal from '../../components/VerifyModal/VerifyModal';
import Icon from '../../components/Icon/Icon';
import formatDate from '../../utils/formatDate';
import { getNormalPageUrl, getRecyclePageUrl } from '../../utils/urlHelper';
import { formatTheVideoPackage } from '../../utils/util';

const doyle = new Doyle();

@withRouter
@connect(
  state => ({
    trashNotesList: getTrashNotesListState(state),
    trashNotes: getTrashNotesState(state),
  }),
  dispatch => ({
    getTrashNotesList: () => dispatch(getTrashNotesList()),
    getTrashNote: noteId => dispatch(getTrashNote(noteId)),
    delTrashNote: (noteId, doneCallback) => dispatch(delTrashNote(noteId, doneCallback)),
    recoveryTrashNote: (noteId, doneCallback) => dispatch(recoveryTrashNote(noteId, doneCallback)),
  }),
)
export default class RecyclePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 'home',
      size: 'large',
      loading: false,
      maxDay: 60,
      listLoading: false,
      contentLoading: false,
      verifyModalVisible: false,
      isRecovering: false,
      isDeleting: false,
    };
    this.props.getTrashNotesList();
  }

  componentWillMount() {
    const { match } = this.props;
    const { params: { noteId } } = match;
    // 刷新时如果有noteId，需要直接获取
    if (noteId) {
      this.props.getTrashNote(noteId);
    }
  }

  componentWillReceiveProps(nextProps) {
    const { trashNotesList, trashNotes, match, history } = nextProps;
    const { params: { noteId } } = match;
    const { state } = history.location; // 需要把state带过去
    const notelistSeq = trashNotesList.get('seq', Immutable.fromJS([]));
    if (!noteId && notelistSeq.size > 0) {
      const hid = notelistSeq.get(0);
      history.replace(`/recycle/${hid}`, state);
    }
    const listStatus = trashNotesList.get('status');
    const listLoading = listStatus === Trash.GET_TRASH_NOTES_LIST;
    const preNoteId = this.props.match.params.noteId;
    // 切换文章时
    if (preNoteId !== noteId && noteId) {
      nextProps.getTrashNote(noteId);
    }
    const contentStatus = trashNotes.getIn([noteId, 'status']);
    const isRecovering = contentStatus === Trash.RECOVERY_TRASH_NOTE;
    const isDeleting = contentStatus === Trash.DEL_TRASH_NOTE;
    const contentLoading = contentStatus === Trash.GET_TRASH_NOTE_CONTENT;

    this.setState({
      listLoading,
      isRecovering,
      contentLoading,
      isDeleting,
    });
  }

  componentDidUpdate() {
    if (this.noteWrapElem) {
      formatTheVideoPackage(this.noteWrapElem);
    }
  }

  noteListItemOnMouseMove = (e) => {
    const spanElem = e.currentTarget.querySelector('span');
    spanElem.innerHTML = i18n.get('trash.del-time', { time: spanElem.getAttribute('data-destroy-date') });
  };

  noteListItemOnMouseLeave = (e) => {
    const spanElem = e.currentTarget.querySelector('span');
    spanElem.innerHTML = i18n.get('trash.del-time2', { time: spanElem.getAttribute('data-destroy-days-left') });
  };

  addDays = (date, days) => {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  };

  renderNoteList = (seq, entities) => {
    const { match } = this.props;
    const { params: { noteId } } = match;
    const { maxDay } = this.state;

    return seq.map((value, k) => {
      const v = entities[value];
      const delAtDate = new Date(v.deleted_at * 1000);

      const timeLeft = maxDay - Math.floor((new Date() - delAtDate) / (3600 * 24 * 1000));
      const willDestroyDate = this.addDays(new Date(v.deleted_at * 1000), 60);
      const itemClass = classNames({
        [styles['active']]: v.id === +noteId,
      });
      return (
        <li
          key={k}
          className={itemClass}
          data-noteid={k}
          onMouseMove={this.noteListItemOnMouseMove}
          onMouseLeave={this.noteListItemOnMouseLeave}
        >
          <Link to={`/recycle/${v.id}`} replace>
            <h5>
              <Icon name='file-text' className={styles['icon-file-text']} fixedWidth/>
              {v.title}
            </h5>
            <span
              data-destroy-days-left={timeLeft}
              data-destroy-date={formatDate(willDestroyDate, 'yyyy-MM-dd')}
            >
              {timeLeft} 天后清除
            </span>
          </Link>
        </li>
      );
    });
  };

  onCloseBtnClick = () => {
    const { history } = this.props;
    const { state = {} } = history.location;
    if (state.canBack) {
      history.goBack();
    } else {
      history.push('/');
    }
  };

  revertNote = (noteId) => {
    const { history } = this.props;
    this.props.recoveryTrashNote(noteId, (error, data) => {
      if (error) {
        Message.error(i18n.get('error.try-again'));
        return;
      }
      history.push(getNormalPageUrl(data.nbId, data.noteId));
    });
  };

  delNote = (noteId) => {
    const { trashNotesList, history } = this.props;
    const seq = trashNotesList.get('seq').toJS();
    const seqIndex = seq.indexOf(+noteId);
    this.props.delTrashNote(noteId, (error = [], data) => {
      if (error && error[0] && error[0].code === 9) {
        this.setState({ verifyModalVisible: true });
        return;
      }
      // 成功跳转到下一篇
      if (!error) {
        history.push(getRecyclePageUrl(seq[seqIndex + 1] || seq[seqIndex - 1]));
      }
    });
  };

  recoveryNoteBtnClick = () => {
    const { match, history } = this.props;
    const { params: { noteId } } = match;
    const { isRecovering } = this.state;
    if (isRecovering) {
      return;
    }
    this.revertNote(noteId);
  };

  onModalCancelClick = () => {
    this.setState({ verifyModalVisible: false });
  };

  onModalConfirmBtnClick = () => {
    const { match } = this.props;
    const { params: { noteId } } = match;
    this.delNote(noteId);
    this.onModalCancelClick();
  };

  delNoteBtnClick = () => {
    const { match } = this.props;
    const { params: { noteId } } = match;
    const { isDeleting } = this.state;
    if (isDeleting) {
      return;
    }
    this.delNote(noteId);
  };

  getContentHTML = () => {
    const { trashNotesList, trashNotes, match } = this.props;
    const { params: { noteId } } = match;
    const content = trashNotes.getIn([noteId, 'content']);
    const noteType = trashNotesList.getIn(['entities', noteId, 'note_type']);
    // 2 --> markdown
    if (noteType === 2) {
      return doyle.parse(content);
    }
    return content;
  };

  render() {
    const {
      isDeleting,
      listLoading,
      contentLoading,
      isRecovering,
      verifyModalVisible,
    } = this.state;
    const { trashNotesList, match } = this.props;
    const { params: { noteId } } = match;
    const notesListSeq = trashNotesList.get('seq', Immutable.fromJS([]));
    const noteListSize = notesListSeq.size;
    const notesListEntities = trashNotesList.get('entities', Immutable.fromJS({}));
    const title = notesListEntities.getIn([noteId, 'title'], '');
    const contentHTML = this.getContentHTML();
    return (
      <Row className={styles['recycle-page']}>
        <Col className={styles['recycle-list-wrap']}>
          <div className={styles['title']}>
            <Icon name='trash' className={styles['icon-trash']} fixedWidth/>
            {i18n.get('trash.trash', { num: noteListSize })}
          </div>
          <ul>
            {
              !!noteListSize &&
              this.renderNoteList(notesListSeq.toJS(), notesListEntities.toJS())
            }
            <NestLoading loading={listLoading}/>
          </ul>
          {
            !noteListSize && <EmptyContent/>
          }
        </Col>
        <Col className={styles['content-wrap']}>
          <div className={styles['title-wrap']}>
            <h3>{title}</h3>
            {!isRecovering && <a onClick={this.onCloseBtnClick} className={styles['close']}>×</a>}
          </div>
          <div className={styles['content-view-wrap']}>
            {
              contentHTML &&
              <div
                className={classNames('note-view', styles['content-view'])}
                dangerouslySetInnerHTML={{ __html: contentHTML }}
                ref={
                  (v) => {
                    this.noteWrapElem = v;
                  }
                }
              />
            }
            {
              !contentLoading && !contentHTML && <EmptyContent/>
            }
            <NestLoading loading={contentLoading}/>
          </div>
          {
            !contentLoading &&
            <div className={styles['footer']}>
              <span
                className={classNames(styles['btn'], styles['btn-recovery'])}
                onClick={this.recoveryNoteBtnClick}
              >
                {isRecovering ? i18n.get('trash.recovering') : i18n.get('trash.recovery')}
              </span>
              <span
                className={classNames(styles['btn'], styles['btn-del'])}
                onClick={this.delNoteBtnClick}
              >
                {isDeleting ? i18n.get('trash.deleting') : i18n.get('trash.delete')}
              </span>
            </div>
          }
          <VerifyModal
            visible={verifyModalVisible}
            onModalCancelClick={this.onModalCancelClick}
            onModalConfirmBtnClick={this.onModalConfirmBtnClick}
          />
        </Col>
      </Row>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/RecyclePage/RecyclePage.js